<template>
   
<!--<b-col md="3" sm="2" style="padding-right:3px;">-->

 <div class="int-sidebar">

	<div class="wrapper" >
		<div class="top">

			<div class="int-sidebar__portion">
				<!-- <a class="design-container-details__sidebar-item flex f-w-semi-bold " href="/brands"><i class="fa fa-2x fa-angle-left"></i>&nbsp;&nbsp;&nbsp; 
				<span>All Designs</span>
				</a> -->
        <router-link :to="'/style_list/' + 'ALL_Designs'" class="design-container-details__sidebar-item flex f-w-semi-bold ">
            
           <i class="fa fa-2x fa-angle-left"></i>&nbsp;&nbsp;&nbsp; 
        <span>All Designs</span>
                
          </router-link>

			</div>

		</div>

		<div class="middle" >

		        <div class=" flex-col ps" style="height: auto;" >
              
              <router-link :to="'/design_details/' + designs.style_id" v-for="designs in nav_design_list">
              
            <!-- <router-link :to="'/design_files/' + route_id" -->
           <!-- <i class="fa fa-2x fa-angle-left"></i>&nbsp;&nbsp;&nbsp; 
        <span>All Designs</span> -->
                
          
		           <!-- <a v-for="designs in nav_design_list" :href="'/design_details/' + designs.style_id"> -->
		              <div class="design-list__item">
		                 <div style="display: flex; align-items: center;" @click="changedesign()">
		                    <div style="width:50px; height: 50px; border-radius: 100px; overflow: hidden;">
                          <div v-if="style_details.style_image_type=='image'">
                              <img v-bind:src="designs.style_image" alt="Design" style="width: 100%; height: 100%;"/>
                            </div>
                          <div  v-if="style_details.style_image_type=='other'" >
                            <vue-pdf-embed :source="designs.style_image" alt="Design" style="width: 100%; height: 100%;" id="sideimg"></vue-pdf-embed>
                          </div>

		                    </div>

                        <!-- <div style="width:100px; height: 50px; border-radius: 100px; overflow: hidden;" >
                        
                            <img v-bind:src="designs.style_image"  alt="Design" class="imgsidedesign">
                        
		                    </div> -->

		                    <div style="padding-left: 12px;">
		                          <!-- {{style_details.style_image}} -->
		                       <div class="design-list__title f-w-semi-bold" data-tip="WHITE HALF SLV T SHIRT" data-place="right" data-delay-show="500" currentitem="false">
                           {{ designs.design_title.substring(0,22)+".." }}
                           </div>
		                       <div class="design-list__subtitle f-sz-sm" style="text-transform: capitalize; color: var(--fill-grey-medium);">kids - girls clothing</div>
		                    </div>
		                 </div>
		              </div>
		           <!-- </a> -->
		           </router-link>
		        </div>

		</div>

		<!-- <div class="bottom">
		        <div class="int-sidebar__portion ">
		           <div class="design-container-details__sidebar-item flex f-w-semi-bold" >Add New Design<i class="fa fa-plus" style="margin-left: auto;"></i></div>&nbsp;
		        </div>

		</div> -->
	</div>



</div>


   
</template>
<script>
  import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
	import CONSTANTS from '@/utils/constants'
	import auth from '@/utils/auth'
	import Vue from 'vue'

	const axios = require('axios')

	export default {
    components: {
         VuePdfEmbed,
      },
	 data () {
	 	return {
	 	  nav_design_list :[],
	 	  selected_design_id: 0,	
	 	  style_details: [],
	 	  result: [],
	 	  style_list:[],
	 	}
	 },
	 
	 created: function() { 

	 	//this.getDesignSampleList();
     this.getdesigndetail();
    
	 },

	 methods: { 

        changedesign: function(){

        },
	 

        /****** Function to Get Design Sample List ********/
        getDesignSampleList: function (value) {

        this.isBusy = true;
        const Obj={
        	"design_id":value
        }

        axios.post(`${CONSTANTS.API_URL}/getstylesamplelist`,Obj)
        .then(response => {
          // JSON responses are automatically parsed.
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {

            this.nav_design_list  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            console.log("@@@@@@@@@@@@@@@")
            console.log( this.nav_design_list)
            
            
            this.isBusy = !this.isBusy;
            
          }else {
           this.design_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })


        },


       /****** Function to design details ********/
       getdesigndetail: function () {
        //document.getElementById("overlay").style.display = "block";
         //alert("testing");
           this.isBusy = true;
       
           const Obj = {
                style_id: this.$route.params.id,              
              }
           axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
           .then(response => {
            document.getElementById("overlay").style.display = "none";
             // JSON responses are automatically parsed.
             this.result = response.data
             if (this.result.returnmsg === 'Successful') {
             
            this.style_details  = this.result.returnvalue[0];
            this.selected_design_id = this.style_details.design_id;
            this.getDesignSampleList(this.selected_design_id);
             }else {
              this.style_details =[];
              this.totalRows=0;
                this.isBusy = !this.isBusy;
             }
   
   
           })
   
       },


	 }

	}
</script>
<style>

.middle {
  flex-grow: 1;
  overflow: auto;
  width:98%;
}

.bottom {
 position: relative;

}

 .int-sidebar.int-sidebar--notification {
   max-width: 300px !important;
   min-width: 300px !important;
   background-color: #0277bd;
   .int-sidebar__portion:first-child {
   box-shadow: inset 0 -1px 0 0 var(--fill-grey-light2);
   }
   }
   .int-sidebar {
   
    min-width: 250px;

  
   background-color: #ffffff;
   flex-direction: column;
   z-index: 2;
   :first-child {
   border-top: 0;
   }
   }
   .int-sidebar__portion {
   border-bottom: 1px solid #d4d4d4;
   border-top: 1px solid #d4d4d4;
   align-items: center;
   }
   .int-sidebar__list {
   flex-grow: 1;
   }

   /*.design-list__title{
    max-width: 160px;
    word-wrap: break-word;
   }*/
   /*.design-list__title {
    margin-bottom: 4px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 160px;
}*/
/*.wrapper {
    display: flex;
    flex-direction: column;
    height: 92vh;
    width: auto;
    background-color: white;
}
.middle {
    flex-grow: 1;
     overflow: auto; 
    max-width: 250px !important;
    overflow-x: scroll;
}*/
</style>